function formatValidationPath(loc: unknown): string {
  if (!Array.isArray(loc)) return '';

  return loc
    .filter((segment) => segment !== 'body')
    .map((segment) => String(segment))
    .join('.');
}

function summarizeValidationErrors(detail: unknown): string | null {
  if (!Array.isArray(detail)) return null;

  const messages = detail
    .map((issue) => {
      if (!issue || typeof issue !== 'object') return '';

      const loc = formatValidationPath((issue as any).loc);
      const message =
        typeof (issue as any).msg === 'string'
          ? (issue as any).msg.trim()
          : '';

      if (!message) return '';
      return loc ? `${loc}: ${message}` : message;
    })
    .filter(Boolean);

  if (!messages.length) return null;
  return messages.slice(0, 3).join('; ');
}

export function getRawApiDetail(error: any): any {
  if (error && typeof error === 'object' && error.detail !== undefined) {
    return error.detail;
  }
  return error;
}

export function getApiErrorMessage(error: any, fallback: string): string {
  const detail = getRawApiDetail(error);

  if (typeof detail === 'string' && detail.trim()) {
    return detail.trim();
  }

  const summarizedValidation = summarizeValidationErrors(detail);
  if (summarizedValidation) {
    return summarizedValidation;
  }

  if (detail && typeof detail === 'object' && !Array.isArray(detail)) {
    if (typeof detail.message === 'string' && detail.message.trim()) {
      return detail.message.trim();
    }
    if (typeof detail.detail === 'string' && detail.detail.trim()) {
      return detail.detail.trim();
    }
  }

  if (typeof error?.message === 'string' && error.message.trim()) {
    return error.message.trim();
  }

  return fallback;
}
